export default __webpack_public_path__ + "static/media/3a.bb88ad2e.jpg";